import { Box, IconButton, Typography, useMediaQuery } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import React, { useState } from "react";
import Navbar from "../../Components/Common/Navbar";
import Footer from "../../Components/Common/Footer";
import CustomButton from "../../Components/Common/CustomButton";
import TextInput from "../../Components/Common/TextInput";
import { useLocation, useNavigate } from "react-router-dom";
import form_fill from "../../Assets/Images/fillForm.png";
import { theme } from "../../Assets/Theme/theme";
import axios from "axios";
import { BASE_URL } from "../../Assets/Constants";
import { toast } from "react-toastify";

function FormFill() {
  const location = useLocation();
  const bookingData = location.state?.bookingData;
  const checkoutData = location.state;
  const [errors, setErrors] = useState([]);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    info: "",
  });
  const isSmallScreen = useMediaQuery("(max-width:1000px)");
  const navigate = useNavigate();

  const handleChange = (event) => {
    const { name, value } = event.target;

    const sanitizedValue = name === "phone" ? value.replace(/\D/g, "") : value;

    setFormData((prev) => ({
      ...prev,
      [name]: sanitizedValue,
    }));

    setErrors((prevErrors) =>
      prevErrors.filter((err) => err?.path !== `guestInfo.${name}`)
    );
  };


  const handleBack = () => {
    navigate(-1);
  };

  const handleSubmit = async () => {
    try {
      const response = await axios.post(
        `${BASE_URL}/user/booking/${bookingData?.data?._id}/step2`,
        {
          guestInfo: {
            name: formData.name,
            email: formData.email,
            phone: formData.phone,
            info: formData.info,
          },
        }
      );
      if (response?.data?.error) {
        const errorResponse = Array.isArray(response?.data?.error)
          ? response?.data?.error
          : [response?.data?.error];
        setErrors(errorResponse);
      } else {
        navigate("/checkout", {
          state: { bookingData: checkoutData, formData: formData },
        });
      }
    } catch (error) {
      console.error("Error submitting the form:", error.response || error);
      if (error?.response?.data?.message) {
        toast.error(error.response?.data?.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        navigate("/checkout", {
          state: { bookingData: checkoutData, formData },
        });
      } else {
        const errorResponse = Array.isArray(error?.response?.data?.error)
          ? error?.response?.data?.error
          : [error?.response?.data?.error];
        setErrors(errorResponse);
      }
    }
  };

  const getErrorMessage = (field) => {
    const fieldError = errors.find((err) => err?.path === `guestInfo.${field}`);
    return fieldError?.msg || null;
  };

  return (
    <>
      <Navbar currency={bookingData?.data?.currency} />
      <Box
        display="flex"
        minHeight="105vh"
        overflow="hidden"
        flexDirection={isSmallScreen ? "column" : "row"}
      >
        {/* Form Section */}
        <Box
          width={isSmallScreen ? "100%" : "60%"}
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          padding={isSmallScreen ? 2 : 8}
        >
          {/* Back Button and Heading */}
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            width="100%"
            marginBottom={2}
          >
            <IconButton onClick={handleBack} aria-label="back">
              <ArrowBackIcon />
            </IconButton>
            <Typography
              fontSize={isSmallScreen ? "44px" : "64px"}
              fontWeight="700"
              textAlign="center"
              flex="1"
            >
              Fill the form
            </Typography>
          </Box>

          {/* Description */}
          <Typography
            fontSize="16px"
            fontWeight="400"
            color="#888"
            marginBottom={4}
            textAlign="center"
            width="100%"
          >
            Please fill the form to continue the checkout process.
          </Typography>

          {/* Input Fields */}
          <Box width={isSmallScreen ? "90%" : "80%"}>
            <TextInput
              label="Name"
              placeholder="Enter Your Name"
              name="name"
              onChange={handleChange}
            />
            {getErrorMessage("name") && (
              <Box color="red" mb={2}>
                {getErrorMessage("name")}
              </Box>
            )}
            <TextInput
              label="Email"
              placeholder="Enter Your Email"
              type="email"
              name="email"
              onChange={handleChange}
            />
            {getErrorMessage("email") && (
              <Box color="red" mb={2}>
                {getErrorMessage("email")}
              </Box>
            )}
            <TextInput
              label="Phone Number"
              placeholder="Enter Your Phone Number"
              type="tel"
              name="phone"
              onChange={handleChange}
              inputMode="numeric"
              pattern="[0-9]*"
              maxLength={10}
              value={formData.phone || ""}
            />

            {getErrorMessage("phone") && (
              <Box color="red" mb={2}>
                {getErrorMessage("phone")}
              </Box>
            )}
            <TextInput
              label="Additional Info"
              placeholder="Additional Info..."
              name="info"
              onChange={handleChange}
              multiline
              rows={4}
            />
            {getErrorMessage("info") && (
              <Box color="red" mb={2}>
                {getErrorMessage("info")}
              </Box>
            )}
          </Box>

          {/* Continue Button */}
          <CustomButton
            onClick={handleSubmit}
            style={{
              marginTop: 24,
              width: isSmallScreen ? "90%" : "80%",
              backgroundColor: theme.colors.orange,
              color: "#FFFFFF",
            }}
          >
            Continue
          </CustomButton>
        </Box>

        {/* Image Section */}
        <Box
          width={isSmallScreen ? "0" : "40%"}
          height="90vh"
          display={isSmallScreen ? "none" : "block"}
          padding={4}
          marginTop={10}
        >
          <img
            src={form_fill}
            alt="Fill Form"
            style={{ width: "100%", height: "100%" }}
          />
        </Box>
      </Box>
      <Footer />
    </>
  );
}

export default FormFill;